<template>
  <h2
    class="title"
    :class="{
      'dark': dark,
      'small': small
    }"
  >
    <slot></slot>
  </h2>
</template>

<script>
export default {
  name: 'Title',
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 48px;
  line-height: 1.13;
  text-align: left;
  margin: 0 auto 33px;
  font-weight: $fw-bold;
  color: $c-darktext;
}
.dark {
  color: white;
}
.small {
  font-size: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapter/Title.vue